import { Partner, PartnerUpdate } from "@types-runway/state";

import { admin } from "../../../api";

const useUpdatePartner = () => {
  const updatePartner = async (
    partnerId: string,
    updatePayload: PartnerUpdate
  ): Promise<Partner | null> => {
    try {
      const { data } = await admin.partnerPut(`/${partnerId}`, { partnerUpdate: updatePayload });
      return data;
    } catch {
      return null;
    }
  };
  return { updatePartner };
};

export default useUpdatePartner;
